// import 'isomorphic-unfetch'; // Optional for IE11 support
import ApolloClient from 'apollo-boost';
import { InMemoryCache } from 'apollo-cache-inmemory';

export default new ApolloClient({
  cache: new InMemoryCache(),
  fetchOptions: { fetch }, // Optional for IE11 support
  uri: process.env.VUE_APP_GRAPHQL_ENDPOINT,
});
